/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NewsFeedIcon16Light } from './NewsFeedIcon16Light';
import { NewsFeedIcon16Regular } from './NewsFeedIcon16Regular';
import { NewsFeedIcon16Solid } from './NewsFeedIcon16Solid';
import { NewsFeedIcon20Light } from './NewsFeedIcon20Light';
import { NewsFeedIcon20Regular } from './NewsFeedIcon20Regular';
import { NewsFeedIcon20Solid } from './NewsFeedIcon20Solid';
import { NewsFeedIcon24Regular } from './NewsFeedIcon24Regular';
import { NewsFeedIcon24Solid } from './NewsFeedIcon24Solid';
import { NewsFeedIcon32Regular } from './NewsFeedIcon32Regular';
import { NewsFeedIcon64Regular } from './NewsFeedIcon64Regular';
var sizes = {
    16: {
        light: NewsFeedIcon16Light,
        regular: NewsFeedIcon16Regular,
        solid: NewsFeedIcon16Solid,
    },
    20: {
        light: NewsFeedIcon20Light,
        regular: NewsFeedIcon20Regular,
        solid: NewsFeedIcon20Solid,
    },
    24: {
        regular: NewsFeedIcon24Regular,
        solid: NewsFeedIcon24Solid,
    },
    32: {
        regular: NewsFeedIcon32Regular,
    },
    64: {
        regular: NewsFeedIcon64Regular,
    },
};
export var NewsFeedIcon = forwardRef('NewsFeedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
